import * as React from 'react';
import { IPortalSectionProps } from 'models/portal/page/portalpagesection';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import { browserHistory } from 'react-router';
require('./style.css');

const approxCharWidth = 10;

interface IProps extends IPortalSectionProps {
	t?: (key: string, options?: any) => string;
	isDragging?: boolean;
}

class ViewType8 extends React.Component<IProps, any> {
	constructor(props) {
		super(props);
		this.onTitleClick = this.onTitleClick.bind(this);
	}

	private getElement(i: number = 0): ISectionTextElement | null {
		const { items } = this.props.section;

		if (!items.length) {
			return null;
		}
		const item = items[0];
		if ((item.elements || []).length < i + 1) {
			return null;
		}
		return item.elements[i] as ISectionTextElement;
	}

	private onTitleClick(e: React.SyntheticEvent) {
		e.preventDefault();
		const element = this.getElement();
		if (!this.props.isDragging && element.redirectUrl) {
			browserHistory.push(element.redirectUrl);
		}
	}

	public render() {
		const element = this.getElement();
		if (!element) {
			return null;
		}
		const variantElement = this.getElement(1);
		const variant = variantElement ? variantElement.text : 'green';
		const title = element.text || '';
		let text = '';
		if (title.length) {
			const charsOnPage = 4000 / approxCharWidth;
			let repeats = Math.ceil((2 * charsOnPage) / title.length);
			if (repeats % 2) {
				// to prevent half-text glitch when the animation resets
				repeats++;
			}
			text = new Array(repeats).fill(title).join('');
		}
		return (
			<div className={'portalPageSectionType8 ' + variant}>
				<h3 onClick={this.onTitleClick}>{text}</h3>
			</div>
		);
	}
}

export { ViewType8 };
